import React from 'react';
import Loadable from 'react-loadable';
import RouteLoading from 'components/RouteLoading';

export default [
  {
    exact: true,
    path: '/home/content/audio/new',
    owner: '/home',
    component: Loadable({
      loader: () => import('./new'),
      loading: () => <RouteLoading />
    })
  },
  {
    exact: true,
    path: '/home/content/audio/:id/mod',
    owner: '/home',
    component: Loadable({
      loader: () => import('./mod'),
      loading: () => <RouteLoading />
    })
  },
];